import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { featuredSlides } from "@/mocks/topics";

export default function FeaturedCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % featuredSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index: number) => {
    setActive((index + featuredSlides.length) % featuredSlides.length);
  };

  const slide = featuredSlides[active];

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-8">
      <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-panel">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="relative h-56 w-full overflow-hidden md:h-80 lg:h-[360px]">
            <img
              key={slide.id}
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 焦点专题`}
              className="h-full w-full animate-kenburns object-cover object-center"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-accent-600 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-line" />
              {slide.kicker}
            </span>
          </div>

          <div className="flex flex-col justify-center p-6 md:p-10">
            <h3 className="text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              {slide.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {slide.subtitle}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${slide.articleId}`}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                查看专题详情
                <i className="ri-arrow-right-line" />
              </Link>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => goTo(active - 1)}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:bg-background-100"
                  aria-label="上一个专题"
                >
                  <i className="ri-arrow-left-s-line text-lg" />
                </button>
                <button
                  type="button"
                  onClick={() => goTo(active + 1)}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:bg-background-100"
                  aria-label="下一个专题"
                >
                  <i className="ri-arrow-right-s-line text-lg" />
                </button>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-2">
              {featuredSlides.map((item, index) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => goTo(index)}
                  aria-label={`切换到 ${item.title}`}
                  className={
                    index === active
                      ? "h-1.5 w-8 rounded-full bg-primary-600 transition-all"
                      : "h-1.5 w-4 rounded-full bg-background-300 transition-all hover:bg-background-400"
                  }
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}